import {
  WSBadge,
  WSDivider,
  WSElement,
  WSFlexBox,
  WSIcon,
  WSLoader,
  WSText
} from "@wingspanhq/fe-component-library";
import {
  AccountStatus,
  AccountUsage,
  IAccount
} from "@wingspanhq/users/dist/lib/interfaces";
import cn from "classnames";
import React from "react";
import { PlaidReAuth } from "../PlaidReAuth/PlaidReAuth";
import { PaymentMethodType } from "./types";
import { getAccountSubName } from "./utils";
import { WSAccountsListV2Props } from "./WSAccountsListV2.component";
import styles from "./WSAccountsListV2.module.scss";

export interface AccountTemplateProps extends Partial<WSAccountsListV2Props> {
  account: IAccount;
}

export const AccountTemplate: React.FC<AccountTemplateProps> = ({
  onEditAccount,
  onDeleteAccount,
  account,
  getAccountSubtitle,
  defaultPaymentMethod,
  isSingleAccountPreview
}) => {
  return (
    <WSElement
      onClick={
        onEditAccount && account.status !== AccountStatus.Disconnected
          ? () => onEditAccount(account, PaymentMethodType.BANK_ACCOUNT)
          : undefined
      }
      data-testid={`account-block-${account.accountId}`}
    >
      <WSFlexBox.CenterY
        ml="XL"
        justify="space-between"
        wrap="nowrap"
        className={cn(styles.account, {
          [styles.hasSingleAccount]: isSingleAccountPreview
        })}
      >
        <WSElement>
          <WSText.Heading5 singleLine>
            {getAccountSubName(account)}
          </WSText.Heading5>
          {getAccountSubtitle && (
            <WSText.ParagraphSmall singleLine>
              {getAccountSubtitle(account)}
            </WSText.ParagraphSmall>
          )}
        </WSElement>
        <WSFlexBox.CenterY wrap="nowrap">
          {account.usage === AccountUsage.Business && (
            <WSBadge mx="S" text="Business" textProps={{ color: "grey700" }} />
          )}
          {defaultPaymentMethod?.accountId === account.accountId && (
            <WSBadge mx="S" text="Default" textProps={{ color: "grey700" }} />
          )}
          <PlaidReAuth accountId={account.accountId}>
            {({ onOpen, status, loading }) =>
              status && (
                <WSElement mx="S" onClick={loading ? undefined : onOpen}>
                  {loading ? (
                    <WSLoader.Spinner size="S" />
                  ) : (
                    <WSText.Heading4
                      data-testid={`reconnectAccount${account.accountId}`}
                      color="red500"
                    >
                      Reconnect
                    </WSText.Heading4>
                  )}
                </WSElement>
              )
            }
          </PlaidReAuth>
          {account.status === AccountStatus.Disconnected && onDeleteAccount && (
            <WSIcon
              mx="S"
              size="S"
              color="blue400"
              name="trash"
              onClick={() => onDeleteAccount?.(account, defaultPaymentMethod)}
            />
          )}
          {onEditAccount && account.status !== AccountStatus.Disconnected && (
            <WSIcon mx="S" size="S" color="blue400" name="pencil" />
          )}
        </WSFlexBox.CenterY>
      </WSFlexBox.CenterY>
      {isSingleAccountPreview ? null : <WSDivider />}
    </WSElement>
  );
};
